<template>
  <div class="j_search_container" ref="containerRef" :class="$style.wraper">
    <a :class="$style.logo" href="/">
      <img :class="$style.logoImg" src="~@/assets/img/global/logo.png" alt="上船吧">
    </a>

    <!-- 位置  -->
    <div :class="$style.location" v-popover:countryPopoverRef>
      <span :class="$style.locationIcon" class="el-icon-location"></span>
      <span :class="$style.locationText">{{ country ? country.name : "国家"}}</span>
      <i class="el-icon-caret-bottom transform transition-transform" :class="[ visibleCountryPopover ? 'rotate-180' : '' ]" />
    </div>

    <!-- 搜索 -->
    <form :class="$style.search" @submit.prevent="onSearch">
      <input v-model="keyword" :class="$style.searchInput" placeholder="关键词、船舶名称" />
      <button :class="$style.searchBtn" type="submit">
        <i class="el-icon-search"></i>
      </button>
    </form>

    <el-popover ref="countryPopoverRef" :popper-class="$style.popoverWraper" v-model="visibleCountryPopover" :visible-arrow="false" :width="containerWidth" placement="bottom"
      :popper-options="popoverOptions">
      <index-country-select @item-click="onCountryClick" />
    </el-popover>
    <!-- <el-popover class="flex-1" v-model="visibleSearchPopover" :visible-arrow="false" ref="popover"
      :popper-class="`${$style.suggestionPopover} ${$style.popoverWraper}`" :popper-options="popoverOptions" :width="containerWidth"
      placement="bottom-end">
      <div slot="reference" :class="$style.search">
        <input v-model="keyword" :class="$style.searchInput" placeholder="船舶公司、船舶名称" />
        <button :class="$style.searchBtn">
          <i class="el-icon-search"></i>
        </button>
      </div>
      <el-scrollbar :wrap-class="$style.suggestionWrap">
        <div v-for="option in searchData.company" :key="`company_${option.id}`" :class="$style.suggestionItem"
          @click="onSearchItemClick(option, 'company')">
          <div :class="$style.suggestionItem__inner">
            <el-image class="w-[70px] h-6" :src="option.logo" />
            <h4 class="font-medium text-dark leading-6 ml-2">{{ option.name }}</h4>
            <span class="text-xxs ml-auto text-secondary leading-6">船舶公司</span>
          </div>
        </div>
        <div v-for="option in searchData.cruise" :key="`cruise_${option.id}`" :class="$style.suggestionItem"
          @click="onSearchItemClick(option, 'cruise')">
          <div :class="$style.suggestionItem__inner">
            <el-image class="w-[70px] h-6" :src="option.logo" />
            <div class="flex-1 ml-2">
              <h4 class="font-medium text-dark leading-6">{{ option.name }}</h4>
              <div class="mt-2 text-secondary text-xxs">
                <p>MMSI/IMO:{{option.mmsi}}<span v-if="option.imo">/{{option.imo}}</span></p>
                <p>品牌：{{option.company_name}}</p>
              </div>
            </div>
            <span class="text-xxs ml-auto text-secondary">{{option.type_label}}</span>
          </div>
        </div>
      </el-scrollbar>
    </el-popover> -->
  </div>
</template>
<script>
import {
	computed,
	defineComponent,
	ref,
	useStore,
	useRouter,
	useRoute,
	watch
} from "@nuxtjs/composition-api";
import { useElementBounding } from "@vueuse/core";
// import useSearch from "./composables/useSearch";
import IndexCountrySelect from "./index-country-select.vue";

export default defineComponent({
	components: { IndexCountrySelect },
	emits: ["update:search-data"],
	setup(props, { emit }) {
		const router = useRouter();
		const route = useRoute();
		const containerRef = ref();
		const { width: containerWidth } = useElementBounding(containerRef);

		const keyword = ref("");

		watch(
			() => route.value.query.keyword,
			(value) => {
				keyword.value = value || "";
			},
			{
				immediate: true
			}
		);
		// const {
		// 	searchData,
		// 	visible: visibleSearchPopover
		// 	// onSelect: onSearchItemClick
		// } = useSearch(keyword, emit);

		const popoverOptions = computed(() => ({
			boundariesPadding: 48
		}));

		const visibleCountryPopover = ref(false);
		const store = useStore();
		const country = computed(() => store.state.cruiseMap.country);

		function onCountryClick(country) {
			store.commit("cruiseMap/setCountry", country);
			visibleCountryPopover.value = false;
		}

		/**
		 * 搜索建议点击
		 * @param {object} option
		 * @param {'company' | 'cruise'} type - option 类型
		 */
		// function onSearchItemClick(option, type) {
		// 	keyword.value = option.name;
		// 	if (type === "company") {
		// 		emit("update:search-data", {
		// 			company_id: [option.id]
		// 		});
		// 	} else {
		// 		window.open(`/company/cruise/${option.id}`, "__blank");
		// 	}

		// 	visibleSearchPopover.value = false;
		// }

		function onSearch() {
			emit('update:search-data', {
				keyword: keyword.value
			})
			// router.replace({
			// 	query: {
			// 		...route.value.query,
			// 		keyword: keyword.value
			// 	}
			// });
		}

		return {
			containerRef,
			containerWidth,

			popoverOptions,

			country,

			// 搜索
			keyword,
			// searchData,
			// visibleSearchPopover,
			// onSearchItemClick,

			visibleCountryPopover,

			onCountryClick,

			onSearch
		};
	}
});
</script>
<style lang="scss" module>
.wraper {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 3rem;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
.logo {
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.logoImg {
  height: 1.75rem;
  width: 5rem;
}
.popoverWraper {
  margin-top: 0.625rem;
}
.location:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.location {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-flex: 0;
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  height: 3rem;
  line-height: 3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  position: relative;
  text-align: center;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.location:after, .location:before {
  content: "";
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
  height: 1.75rem;
  margin-top: -0.875rem;
  position: absolute;
  top: 50%;
  width: 1px;
}
.location::before {
  left: 0px;
}
.location::after {
  right: 0px;
}
.location:hover .locationIcon, .location:hover .locationText {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.locationIcon {
  font-size: 0.75rem;
  line-height: 1rem;
}
.locationText {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 0.125rem;
  margin-right: 0.125rem;
  max-width: 4em;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.search {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 3rem;
}
.searchInput {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width: 100%;
}
.searchBtn {
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  line-height: 1.25rem;
  margin-right: 0.75rem;
  text-align: center;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.searchBtn:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.suggestionPopover {
  padding: 0px;
}
.suggestionWrap {
  max-height: calc(100vh - 144px);
}
.suggestionItem:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.suggestionItem {
  cursor: pointer;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.suggestionItem__inner {
  border-bottom-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.suggestionItem:last-child .suggestionItem__inner {
  border-style: none;
}
</style>